.text {
  margin: 0;
}

.size-xs {
  font-size: var(--text-xs);
}
.size-sm {
  font-size: var(--text-sm);
}
.size-base {
  font-size: var(--text-base);
}
.size-lg {
  font-size: var(--text-lg);
}
.size-xl {
  font-size: var(--text-xl);
}
.size-2xl {
  font-size: var(--text-2xl);
}
.size-3xl {
  font-size: var(--text-3xl);
}

.weight-normal {
  font-weight: var(--weight-normal);
}
.weight-medium {
  font-weight: var(--weight-medium);
}
.weight-semibold {
  font-weight: var(--weight-semibold);
}

.tone-primary {
  color: var(--text-primary);
}
.tone-secondary {
  color: var(--text-secondary);
}
.tone-muted {
  color: var(--text-muted);
}
.tone-positive {
  color: var(--intent-positive);
}
.tone-warning {
  color: var(--intent-warning);
}
.tone-danger {
  color: var(--intent-danger);
}

.heading {
  line-height: var(--leading-tight);
  letter-spacing: -0.01em;
  text-wrap: balance;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
